import PropTypes from "prop-types";
import { Route, Switch, Link, NavLink } from "react-router-dom";
import React, { Component } from "react";
import Logo from "./Logo";
import UnitedTathataLogo from "./UnitedTathataLogo";
import Icon from "../common/icons/Icon";
import classNames from "classnames";
import store from "store2";
import config from "../config";

export default class extends Component {
  static propTypes = {
    hasMsAdminAccess: PropTypes.bool,
    hasActiveSubscription: PropTypes.bool.isRequired,
    isAccountNavOpen: PropTypes.bool,
    isMobile: PropTypes.bool,
    isMobileNavOpen: PropTypes.bool,
    location: PropTypes.object,
    toggleAccountNav: PropTypes.func,
    toggleMobileNav: PropTypes.func,
    userLoaded: PropTypes.bool,
  };

  renderLogo = () => {
    const {
      location: { pathname },
    } = this.props;

    if (
      ["/", "/trial"].indexOf(pathname) >= 0 ||
      (pathname === "/gift-subscription" && !store.get(config.auth.idTokenKey))
    ) {
      return (
        <a className="logo" href="https://www.tathatagolf.com">
          <Logo />
        </a>
      );
    }
    if (pathname === "/mileageplus") {
      return (
        <a className="logo" href="https://www.tathatagolf.com">
          <UnitedTathataLogo />
        </a>
      );
    }

    return (
      <Link className="logo" to="/subscription/dashboard">
        <Logo />
      </Link>
    );
  };

  renderMobileNavigation = (items) => {
    const mobileClasses = {
      drawer__nav: true,
      "drawer__nav--open": this.props.isMobileNavOpen,
    };

    return (
      <div className="navigation--mobile">
        <button
          type="button"
          className="hamburger"
          onClick={this.props.toggleMobileNav}
        >
          <Icon icon={this.props.isMobileNavOpen ? "Close" : "Hamburger"} />
        </button>
        <nav className={classNames(mobileClasses)}>
          {items.map(this.renderNavItem)}
          {this.renderAccountNav()}
        </nav>
      </div>
    );
  };

  renderNavItem = (item) => {
    return (
      <NavLink key={item.name} to={item.route} activeClassName="active">
        {item.name}
      </NavLink>
    );
  };

  renderAccountNav = () => {
    return (
      <div>
        {this.props.hasActiveSubscription && (
          <div>
            <Link to="/subscription/profile">My Profile</Link>
            <Link to="/subscription/billing">Billing</Link>
            <Link to="/subscription/follow-ups">Follow-Ups</Link>
          </div>
        )}
        {this.props.hasMsAdminAccess && (
          <Link to="/subscription/ms-admin">MS Admin</Link>
        )}
        <Link to="/logout">Log Out</Link>
      </div>
    );
  };

  renderDesktopNavigation = (items) => {
    return (
      <div className="navigation--desktop">
        <nav className="header__nav">{items.map(this.renderNavItem)}</nav>
        <div className="account">
          <button
            className="account__image"
            onClick={this.props.toggleAccountNav}
          >
            <img
              src="https://d27vybgvtr1dba.cloudfront.net/default_profile_img.png"
              alt="Account Settings Dropdown"
            />
          </button>
          {this.props.isAccountNavOpen ? (
            <div className="account__dropdown">
              <nav className="account__nav">{this.renderAccountNav()}</nav>
            </div>
          ) : null}
        </div>
      </div>
    );
  };

  renderNavigation = () => {
    let items;

    if (!this.props.userLoaded) {
      return null;
    }

    if (!this.props.hasActiveSubscription) {
      items = [
        {
          name: "Billing",
          route: "/subscription/billing",
        },
        {
          name: "Courses",
          route: "/subscription/courses",
        },
      ];
    } else {
      items = [
        {
          name: "Courses",
          route: "/subscription/courses",
        },
        {
          name: "Tathata TV",
          route: "/subscription/tv",
        },
        {
          name: "Library",
          route: "/subscription/library",
        },
        {
          name: "Train With Bryan",
          route: "/subscription/coaching",
        },
      ];
    }

    return this.props.isMobile
      ? this.renderMobileNavigation(items)
      : this.renderDesktopNavigation(items);
  };

  renderUnderlay = () => {
    if (this.props.isMobileNavOpen || this.props.isAccountNavOpen) {
      return (
        <button className="underlay" onClick={this.props.onCloseUnderlay} />
      );
    }
  };

  render() {
    const loggedOutHeader = () => (
      <div className="navigation--desktop">
        <nav className="header__nav">
          <NavLink to="/subscription" activeClassName="active">
            Sign In
          </NavLink>
        </nav>
      </div>
    );

    const giftSubscriptionRouteProps = store.get(config.auth.idTokenKey)
      ? {
          render: this.renderNavigation,
        }
      : {
          component: loggedOutHeader,
        };

    return (
      <header className="header">
        <div className="container">
          {this.renderLogo()}
          {process.env.REACT_APP_ENV === "development" ? (
            <div className={`env-string--${process.env.REACT_APP_ENV}`}>
              DEV
            </div>
          ) : null}
          {process.env.REACT_APP_ENV === "qa" ? (
            <div className={`env-string--${process.env.REACT_APP_ENV}`}>QA</div>
          ) : null}
          {process.env.REACT_APP_ENV === "staging" ? (
            <div className={`env-string--${process.env.REACT_APP_ENV}`}>
              STAGING
            </div>
          ) : null}
          <Switch>
            <Route path="/subscription" render={this.renderNavigation} />
            <Route exact path="/" component={loggedOutHeader} />
            <Route exact path="/trial" component={loggedOutHeader} />
            <Route exact path="/mileageplus" component={loggedOutHeader} />
            <Route
              exact
              path="/gift-subscription"
              {...giftSubscriptionRouteProps}
            />
          </Switch>
        </div>
        {this.renderUnderlay()}
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./src/layout/Header.js